import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography } from 'common/typography';
import merchantTyping from 'lottie/merchant_typing.json';
import scientistError from 'lottie/scientist_error.json';

import { PageHeader } from './page-header/PageHeader';

type MessagePageProps = {
  variant: 'error' | 'not_supported' | 'missing_permissions';
  title?: string;
  description?: string;
};

const MessagePageContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 32px;
  margin-block-end: 20%;
`;

const MessageHeaderMapping: Record<MessagePageProps['variant'], string> = {
  error: 'error-page.header',
  not_supported: 'not-supported-page.header',
  missing_permissions: 'missing-permissions.header',
};

const MessageDescriptionMapping: Record<MessagePageProps['variant'], string> = {
  error: 'error-page.description',
  not_supported: 'not-supported-page.description',
  missing_permissions: 'missing-permissions.description',
};

export const MessagePage = ({ variant, title, description }: MessagePageProps) => {
  const lottieFile = variant === 'error' ? scientistError : merchantTyping;
  return (
    <>
      <PageHeader />
      <MessagePageContainer>
        <Player autoplay loop src={lottieFile} style={{ height: '300px', width: '300px' }}></Player>
        <Typography.Heading2>{title ?? <FormattedMessage id={MessageHeaderMapping[variant]} />}</Typography.Heading2>
        <Typography.Body2>
          {description ?? <FormattedMessage id={MessageDescriptionMapping[variant]} />}
        </Typography.Body2>
      </MessagePageContainer>
    </>
  );
};

export default MessagePage;
